import * as types from "../actions/types";

/******************* 
@purpose : Intital vehicle reducer data
@Author : INIC
******************/
const initialState = {
  vehicleAvailableForDriveNow: false,
  vehicleData: "",
  vehicleSlot: "",
};

/******************* 
@purpose : Vehicle Reducer
@Parameter : {ini_data, action}
@Author : INIC
******************/
export default function vehicle(ini_data = initialState, action = {}) {
  switch (action.type) {
    case types.SET_VEHICLE_AVAILABLE_FOR_DRIVE_NOW:
      return Object.assign({}, ini_data, {
        vehicleAvailableForDriveNow: true,
      });
    case types.RESET_VEHICLE_AVAILABLE_FOR_DRIVE_NOW:
      return Object.assign({}, ini_data, {
        vehicleAvailableForDriveNow: false,
      });
    case types.SET_VEHICLE_DATA:
      return Object.assign({}, ini_data, {
        vehicleData: action.data ? { ...ini_data.data, ...action.data } : "",
      });
    case types.SET_VEHICLE_AVAILABLE_SLOT:
      return Object.assign({}, ini_data, {
        vehicleSlot: action.data ? { ...ini_data.data, ...action.data } : "",
      });

    default:
      return ini_data;
  }
}

/*******************
@purpose :  Set vehicle available for drive now
@Parameter : {}
@Author : INIC
******************/
export const setVehicleAvailableForDriveNow = () => {
  return {
    type: types.SET_VEHICLE_AVAILABLE_FOR_DRIVE_NOW,
  };
};

/*******************
@purpose :  Reset vehicle available for drive now
@Parameter : {}
@Author : INIC
******************/
export const resetVehicleAvailableForDriveNow = () => {
  return {
    type: types.RESET_VEHICLE_AVAILABLE_FOR_DRIVE_NOW,
  };
};
